import { render } from "./ProfileComponent.vue?vue&type=template&id=7368ba36&scoped=true"
import script from "./ProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&lang=js"

import "./ProfileComponent.vue?vue&type=style&index=0&id=7368ba36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7368ba36"]])

export default __exports__